<template>
  <div class="main-wrapper">
    <div v-if="current_page===0">
      <p class="title">请填写报告收件地址</p>
      <van-field
            v-model="deliveryCompanyName"
            placeholder="请填写收件公司名称（可为空）"
            clearable
            label="公司名称"
          />
      <van-address-edit
        :area-list="areaList"
        :address-info="deliveryAddress"
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        @save="onSave"
        :detail-rows="2"
        save-button-text="下一步"
      >
      </van-address-edit>
    </div>
    <div v-if="current_page===1">
      <p class="title">请确认和补充报告抬头信息</p>
      <div>
        <van-cell-group>
          <van-field
            v-model="objectParty.company_name"
            placeholder="请输入公司名称"
            required
            clearable
            :error="error.objectParty.company_name"
            label="公司名称"
            right-icon="question-o"
            @click-right-icon="$toast('该名称将用于报告封面')"
            @focus="clearError"
          />
          <van-field
            v-model="objectParty.address"
            placeholder="请输入公司地址"
            required
            clearable
            :error="error.objectParty.address"
            label="地址"
            right-icon="question-o"
            @click-right-icon="$toast('该地址将用于报告封面')"
            @focus="clearError"
          />
          <van-field
            v-model="objectParty.telephone"
            placeholder="请填写固定电话（可为空）"
            clearable
            label="固定电话"
            right-icon="question-o"
            @click-right-icon="$toast('公司固定电话，便于联系,可为空')"
          />
          <van-field
            v-model="objectParty.fax"
            placeholder="请填写公司传真（可为空）"
            clearable
            label="传真"
            right-icon="question-o"
            @click-right-icon="$toast('公司传真，可为空')"
          />
          <van-field
            v-model="objectParty.person"
            placeholder="请输入负责本次业务的联系人"
            required
            clearable
            :error="error.objectParty.person"
            label="联系人"
            right-icon="question-o"
            @click-right-icon="$toast('贵公司负责在本次检测业务的联系人')"
            @focus="clearError"
          />
          <van-field
            v-model="objectParty.mobile"
            placeholder="请输入联系人电话"
            required
            clearable
            :error="error.objectParty.mobile"
            label="移动电话"
            right-icon="question-o"
            @click-right-icon="$toast('联系人的手机号')"
            @focus="clearError"
          />
          <van-field
            v-model="objectParty.email"
            placeholder="请输入联系人电子邮箱(可为空)"
            clearable
            :error="error.objectParty.email"
            label="电子邮箱"
            right-icon="question-o"
            @click-right-icon="$toast('联系人的电子邮箱')"
            @focus="clearError"
          />
        </van-cell-group>
      </div>
      <div class="button-wrapper">
        <button @click="lastStep">上一步</button>
        <button @click="nextStep('objectParty')">下一步</button>
      </div>
    </div>
    <div v-if="current_page===2">
      <p class="title">请确认和补充发票信息</p>
      <div>
        <van-cell-group>
          <van-field
            v-model="invoice.title"
            placeholder="请输入发票抬头"
            required
            clearable
            :error="error.invoice.title"
            label="发票抬头"
            right-icon="question-o"
            @click-right-icon="$toast('本次业务所出具发票的公司抬头')"
            @focus="clearError"
          />
          <van-field
            v-model="invoice.comid"
            placeholder="请输入纳税人识别号"
            required
            clearable
            :error="error.invoice.comid"
            label="纳税人识别号"
            right-icon="question-o"
            @click-right-icon="$toast('公司的统一社会信用代码')"
            @focus="clearError"
          />
          <van-field
            v-model="invoice.addr"
            placeholder="请输入注册地址"
            required
            clearable
            :error="error.invoice.addr"
            label="注册地址"
            right-icon="question-o"
            @click-right-icon="$toast('公司营业执照上的注册地址')"
            @focus="clearError"
          />
          <van-field
            v-model="invoice.telno"
            placeholder="请输入注册电话"
            required
            clearable
            :error="error.invoice.telno"
            label="注册电话"
            right-icon="question-o"
            @click-right-icon="$toast('公司营业执照上的注册电话')"
            @focus="clearError"
          />
          <van-field
            v-model="invoice.bankname"
            placeholder="请输入开户银行名称"
            required
            clearable
            :error="error.invoice.bankname"
            label="用户银行"
            right-icon="question-o"
            @click-right-icon="$toast('公司基本户的开户行')"
            @focus="clearError"
          />
          <van-field
            v-model="invoice.bankaccount"
            placeholder="请输入银行账户"
            required
            clearable
            :error="error.invoice.bankaccount"
            label="银行账户"
            right-icon="question-o"
            @click-right-icon="$toast('公司银行账户')"
            @focus="clearError"
          />
        </van-cell-group>
      </div>
      <div class="button-wrapper">
        <button @click="lastStep">上一步</button>
        <button @click="nextStep('invoice')">提交</button>
      </div>
    </div>
    <div v-if="current_page===3">
      <p class="title">请再次核对已填写信息</p>
      <div>
          <div class="check-div">
              <p class="sub-title">报告完成后我们将会把报告寄送至如下地址：</p>
              <p class="confirm-content"><span class="cc">{{totalAddress}}</span></p>
          </div>
            <div class="check-div">
                <p class="sub-title">报告封面的公司名称和地址如下：</p>
                <p class="confirm-content">委托单位：<span class="cc">{{this.objectParty.company_name}}</span></p>
                <p class="confirm-content">委托单位地址：<span class="cc">{{this.objectParty.address}}</span></p>
                </div>
                <div class="check-div">
                <p class="sub-title">在业务过程中如有问题我们将联系：</p>
                <p class="confirm-content">
                <span class="cc">{{this.objectParty.person}}</span><span>(先生/女士)</span>
                <span class="cc">{{','+this.objectParty.mobile}}</span>
                <span class="cc">{{this.objectParty.email?','+this.objectParty.email:''}}</span></p>
                </div>
                <div class="check-div">
                    <p class="sub-title">我公司提供发票时将按如下信息开具：</p>
                    <p class="confirm-content">公司抬头：<span class="cc">{{this.invoice.title}}</span></p>
                    <p class="confirm-content">纳税人识别号：<span class="cc">{{this.invoice.comid}}</span></p>
                    <p class="confirm-content">注册地址：<span class="cc">{{this.invoice.addr}}</span></p>
                    <p class="confirm-content">注册电话：<span class="cc">{{this.invoice.telno}}</span></p>
                    <p class="confirm-content">用户银行：<span class="cc">{{this.invoice.bankname}}</span></p>
                    <p class="confirm-content">银行账户：<span class="cc">{{this.invoice.bankaccount}}</span></p>
                    <p class="confirm-content">发票类型：<span class="cc">增值税专用发票</span></p>
                    <p class="confirm-content">发票内容：<span class="cc">检测费用</span></p>
                    </div>        
      </div>
      <div class="button-wrapper">
          <button @click="lastStep">返回修改</button>
        <button @click="submit">确认</button>
      </div>
    </div>
  </div>
</template>
<script>
import areaList from "./area.js";
function objectPartyFac() {
  return {
    company_name: "",
    address: "",
    telephone: "",
    fax: "",
    person: "",
    mobile: "",
    email:""
  };
}

function deliveryAddressFac() {
  return {
    id: "",
    name: "",
    tel: "",
    province: "",
    city: "",
    county: "",
    addressDetail: "",
    areaCode: "",
    ifDefault: false
  };
}

function invoiceFac() {
  return {
    title: "",
    comid: "",
    addr: "",
    telno: "",
    bankname: "",
    bankaccount: ""
  };
}

function errorFac(){
    return {
        invoice:{
    title: false,
    comid: false,
    addr: false,
    telno: false,
    bankname: false,
    bankaccount: false
  },
  objectParty:{
      company_name: false,
    address: false,
    telephone: false,
    fax: false,
    person: false,
    mobile: false,
    email:false
  },
    };
}
export default {
  name: "completeCustomer",
  components: {},
  props: {
    project_enid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      areaList:areaList,
      spinStat:false,
      searchResult: [],
      objectParty: objectPartyFac(),
      deliveryAddress: deliveryAddressFac(),
      deliveryCompanyName:"",
      invoice: invoiceFac(),
      error:errorFac(),
      current_page: 0
    };
  },
  created() {},
  computed:{
      totalAddress:function(){
          return this.deliveryAddress.name+'，'+this.deliveryAddress.tel+'，'+this.deliveryAddress.province+this.deliveryAddress.city+this.deliveryAddress.county+this.deliveryAddress.addressDetail+(this.deliveryCompanyName?('('+this.deliveryCompanyName+')'):'');
      }
  },
  methods: {
    onSave(value) {
      this.deliveryAddress = JSON.parse(JSON.stringify(value));
      if(!this.objectParty.address.trim()){
          this.objectParty.address = this.deliveryAddress.province+this.deliveryAddress.city+this.deliveryAddress.county+this.deliveryAddress.addressDetail;
        }
        if(!this.objectParty.person.trim()){
          this.objectParty.person = this.deliveryAddress.name;
        }
        if(!this.objectParty.mobile.trim()){
          this.objectParty.mobile = this.deliveryAddress.tel;
        }
        if(this.deliveryCompanyName.trim()&&!this.objectParty.company_name.trim()){
          this.objectParty.company_name = this.deliveryCompanyName.trim();
        }
      this.current_page++;
    },
    lastStep() {
      this.current_page--;
    },
    nextStep(val) {
      if(val==='objectParty'&&this.checkObjectParty()){
        if(!this.invoice.title.trim()&&this.objectParty.company_name.trim()){
          this.invoice.title = this.objectParty.company_name.trim();
        }        
          this.current_page++;
      }else if(val==='invoice'&&this.checkInvoice()){
          this.current_page++;
      }
    },
    clearError(){
        this.error = errorFac(); 
    },
    checkObjectParty(){
        if(!this.objectParty.company_name.trim()){
            this.error.objectParty.company_name = true;
            return false;
        }else if(!this.objectParty.address.trim()){
            this.error.objectParty.address = true;
            return false;
        }else if(!this.objectParty.person.trim()){
            this.error.objectParty.person = true;
            return false;
        }else if(!this.objectParty.mobile.trim()){
            this.error.objectParty.mobile = true;
            return false;
        }else if(!(/^1[3456789]\d{9}$/.test(this.objectParty.mobile))){
            this.error.objectParty.mobile = true;
            this.$toast('联系人手机号格式不正确，请重新填写！');
            return false;
        }else if(this.objectParty.email.trim()&&!(/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.objectParty.email))){
            this.error.objectParty.email = true;
            this.$toast('联系人电子邮箱格式不正确，请重新填写！');
            return false;
        }else{
            return true;
        }
    },
    checkInvoice(){
        if(!this.invoice.title.trim()){
            this.error.invoice.title = true;
            return false;
        }else if(!this.invoice.comid.trim()){
            this.error.invoice.comid = true;
            return false;
        }else if(!(/^[0-9a-zA-Z]{15,20}$/.test(this.invoice.comid.trim()))){
            this.error.invoice.comid = true;
            this.$toast('纳税人识别号格式有误，应为15或18位字符！');
            return false;
        }
        else if(!this.invoice.addr.trim()){
            this.error.invoice.addr = true;
            return false;
        }
        else if(!this.invoice.telno.trim()){
            this.error.invoice.telno = true;
            return false;
        }
        else if(!this.invoice.bankname.trim()){
            this.error.invoice.bankname = true;
            return false;
        }
        else if(!this.invoice.bankaccount.trim()){
            this.error.invoice.bankaccount = true;
            return false;
        }
        else{
            return true;
        }
    },
    submit(){
      this.spinStat = true;
      this.$axios
          .post(this.$url + "/customer_review", {
            askData: 'reviewInfo',
            project_enid: this.project_enid,
            deliveryAddress:this.deliveryAddress,
            deliveryCompanyName:this.deliveryCompanyName,
            objectParty:this.objectParty,
            invoice:this.invoice
          })
          .then(response => {
            if (response.data.stat === "ok") {
              this.$router.replace({name:'review_success'});
            } else if(response.data.stat === "noAuth"){
              this.spinStat = false;
              this.$toast('该页面已使用过或已过期，请联系公司客服重新授权！');
            }else {
              this.spinStat = false;
              this.$toast('数据上传失败，请确认网络连接或联系本公司客服');
            }
          }); 

    }
  }
};
</script>
<style scoped>
.main-wrapper {
  padding: 0 0.2rem;
}
.check-div p{
  margin:0.5rem 0;
}
.title {
  font-size: 0.8rem;
  text-align: center;
  margin:1.5rem 0;
}
.button-wrapper {
  display: flex;
  display: -webkit-flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 3rem 0.3rem;
}

.last-button-wrapper{
    justify-content: center;
}

button {
  border: none;
  outline: none;
  background: #ee0a24;
  color: #fff;
  font-size: 0.8rem;
  padding: 0 2rem;
  border-radius: 0.1rem;
  height: 2rem;
}
.sub-title{
    font-size:0.5rem;
    font-weight:600;
}
.confirm-content{
    font-size:0.6rem;
    padding: 0 0.6rem;
}

.cc{
  font-weight:800;
}
.check-div{
    border-bottom:1px solid #333;
}

</style>